import { IAddressType } from "models/AddressType/addressTypeModel";
import { BaseService } from "./base.service";

class AddressTypeServiceInternal extends BaseService {
	getAddressTypeList = async (): Promise<IAddressType[]> =>
		this.callApi<IAddressType[]>(
			`SupplierAddressType/GetSupplierAddressTypeList`,
			"GET"
		);
}

export const AddressTypeService = new AddressTypeServiceInternal();
